import React, { useCallback, useMemo, useState } from "react";

export type PickupAssignmentMapSyncValue = {
  focusStopId: string | null;
  focusStopVersion: number;
  requestFocusStop: (stopId: string) => void;
  focusDriverDroppableId: string | null;
  focusDriverVersion: number;
  requestFocusDriver: (droppableId: string) => void;
};

export function usePickupAssignmentMapSyncState(): PickupAssignmentMapSyncValue {
  const [focusStopId, setFocusStopId] = useState<string | null>(null);
  const [focusStopVersion, setFocusStopVersion] = useState(0);
  const [focusDriverDroppableId, setFocusDriverDroppableId] = useState<string | null>(null);
  const [focusDriverVersion, setFocusDriverVersion] = useState(0);

  const requestFocusStop = useCallback((stopId: string) => {
    setFocusStopId(stopId);
    setFocusStopVersion((v) => v + 1);
  }, []);

  const requestFocusDriver = useCallback((droppableId: string) => {
    setFocusDriverDroppableId(droppableId);
    setFocusDriverVersion((v) => v + 1);
  }, []);

  return useMemo(
    () => ({
      focusStopId,
      focusStopVersion,
      requestFocusStop,
      focusDriverDroppableId,
      focusDriverVersion,
      requestFocusDriver,
    }),
    [
      focusStopId,
      focusStopVersion,
      requestFocusStop,
      focusDriverDroppableId,
      focusDriverVersion,
      requestFocusDriver,
    ]
  );
}

export const PickupAssignmentMapSyncContext = React.createContext<PickupAssignmentMapSyncValue | null>(null);
